import BaseAPI from "@/apis/base/base-api";

class DBOptionAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "DBOption";
}

export default new DBOptionAPI();
